// removed by extract-text-webpack-plugin
module.exports = {"dashboardWrapper":"src-components-Dashboard-__Dashboard-module___dashboardWrapper","coursesButton":"src-components-Dashboard-__Dashboard-module___coursesButton","coursesLink":"src-components-Dashboard-__Dashboard-module___coursesLink","coursesPresentation":"src-components-Dashboard-__Dashboard-module___coursesPresentation"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Dashboard/Dashboard.module.css
// module id = 256
// module chunks = 0